import React, { useState, useEffect } from 'react';
import { fetchCustomers, saveCustomer, deleteCustomer } from '../../services/api';

const emptyForm = { 
  name: '', 
  gstin: '', 
  contact: '', 
  email: '', 
  address: '', 
  city: '',
  type: '', 
  credit: 0, 
  balance: 0, 
  status: 'Active1' 
};

export default function Customer({ user }) {

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState(emptyForm);

  const companyId = user?.Companyid || user?.company_id || "1";

  useEffect(() => {
    loadData();
  }, [companyId]);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await fetchCustomers(companyId);
      console.log('Customer API Response:', res);
      if (res.success) {
        const raw = res.Response || res.data || res.item;
        const list = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        // Map fields to consistent internal format
        const mappedList = list.map(c => ({
          ...c,
          Type: c.Type || c.type || 'Cash',
          Status: c.Status || c.status || 'Active1',
          Balance: parseFloat(c.Balance || c.balance || 0)
        }));
        setCustomers(mappedList);
      }
    } catch (err) {
      console.error('Failed to load customers:', err);
      // Fallback to static data if API fails (optional)
      // setCustomers(initialCustomers);
    } finally {
      setLoading(false);
    }
  };

  const openAdd = () => {
    setEditId(null);
    setForm(emptyForm);
    setShowForm(true);
  };

  const openEdit = (c) => {
    // Specifically use Customerid as requested for IDS
    const id = c.Customerid || c.id || c.ID;
    setEditId(id);
    setForm({
      name: c.Name || c.name,
      gstin: c.GSTIN || c.gstin || '',
      contact: c.Contact || c.contact || '',
      email: c.Email || c.email || '',
      address: c.Address1 || c.address || '',
      city: c.City || '',
      type: c.Type || c.type || '',
      credit: c.CreditLimit || c.credit || 0,
      balance: c.Balance || c.balance || 0,
      status: (c.Status || c.status || 'Active1').toString() === 'Active' ? 'Active1' : (c.Status || c.status || 'Active1')
    });
    setShowForm(true);
  };

  const handleSave = async () => {
    if (!form.name) return;
    
    if (form.contact && form.contact.length !== 10) {
      alert('Contact Number must be exactly 10 digits');
      return;
    }

    const payload = {
      Companyid: companyId,
      Name: form.name,
      GSTIN: form.gstin,
      Contact: form.contact,
      Address1: form.address,
      City: form.city || 'Hyderabad',
      CreditLimit: String(form.credit),
      Email: form.email,
      Type: form.type,
      Balance: String(form.balance),
      Status: form.status,
      IDS: editId ? editId.toString() : "0"
    };

    setLoading(true);
    try {
      const res = await saveCustomer(payload);
      if (res.success || res.Response === "UPDATED" || res.Response === "INSERTED") {
        alert(res.message || 'Customer saved successfully');
        loadData();
        setShowForm(false);
      } else {
        alert(res.message || 'Failed to save customer');
      }
    } catch (err) {
      console.error('Save error:', err);
      alert('Error saving customer');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (customer) => {
    const id = customer.Customerid || customer.id || customer.ID;
    if (!id || !window.confirm('Are you sure you want to delete this customer?')) return;
    
    setLoading(true);
    try {
      const res = await deleteCustomer(id);
      if (res.success || res.Response === "DELETED") {
        alert(res.message || 'Customer deleted successfully');
        loadData();
      } else {
        alert(res.message || 'Failed to delete customer');
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Error deleting customer');
    } finally {
      setLoading(false);
    }
  };


  const filtered = customers.filter(c =>
    (c.Name || c.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (c.Contact || c.contact || '').toLowerCase().includes(search.toLowerCase())
  );

  const totalCredit = customers
    .filter(c => String(c.Type || c.type || '').toLowerCase() === 'credit')
    .reduce((a, c) => a + (parseFloat(c.Balance || c.balance) || 0), 0);
  const creditCustomers = customers.filter(c => String(c.Type || c.type || '').toLowerCase() === 'credit').length;
  const activeCustomers = customers.filter(c => {
    const s = String(c.Status || c.status || 'Active1').toLowerCase();
    return s === 'active' || s === 'active1';
  }).length;
  return (
    <div className="pump-page">

      <div className="page-header">

        <h2 className="page-title">
          Customer Master
        </h2>

        <div style={{ display:'flex', gap:8 }}>

          <input
            className="form-control"
            style={{ width:200 }}
            placeholder="Search customer..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />

          <button
            className="btn btn-primary btn-sm"
            onClick={openAdd}
          >
            ＋ Add Customer
          </button>

        </div>

      </div>

      {/* Summary Cards */}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))', gap:12, marginBottom:14 }}>

        {[
          { label:'Total Customers', val:customers.length, color:'var(--primary)' },
          { label:'Credit Customers', val:creditCustomers, color:'var(--warning)' },
          { label:'Total Outstanding', val:'₹' + totalCredit.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }), color:'var(--danger)' },
          { label:'Active Customers', val:activeCustomers, color:'var(--secondary)' },
        ].map(c => (

          <div key={c.label}
            style={{
              background:'#fff',
              border:'1px solid var(--border)',
              borderRadius:'var(--radius)',
              padding:'12px 16px',
              boxShadow:'var(--shadow-sm)',
              borderLeft:`4px solid ${c.color}`
            }}
          >

            <div style={{ fontSize:20, fontWeight:800, color:c.color }}>
              {c.val}
            </div>

            <div style={{ fontSize:11.5, color:'var(--text-secondary)', fontWeight:600 }}>
              {c.label}
            </div>

          </div>

        ))}

      </div>

      {showForm && (

        <div className="section-card">

          <div className="section-header">
            {editId ? 'Edit Customer' : 'Add Customer'}
          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Customer Name</label>
              <input className="form-control"
                value={form.name}
                onChange={e => setForm({ ...form, name:e.target.value })}
                placeholder="Party Name"
              />
            </div>

            <div className="form-group">
              <label>GSTIN</label>
              <input className="form-control"
                value={form.gstin}
                onChange={e => setForm({ ...form, gstin:e.target.value })}
                placeholder="Optional"
              />
            </div>

            <div className="form-group">
              <label>Contact No.</label>
              <input 
                className="form-control"
                value={form.contact}
                onChange={e => {
                  const val = e.target.value.replace(/\D/g, '').substring(0, 10);
                  setForm({ ...form, contact: val });
                }}
                placeholder="10-digit mobile"
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input className="form-control"
                value={form.email}
                onChange={e => setForm({ ...form, email:e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Address</label>
              <input className="form-control"
                value={form.address}
                onChange={e => setForm({ ...form, address:e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Type</label>
              <select 
                className="form-control"
                value={form.type}
                onChange={e => setForm({ ...form, type:e.target.value })}
              >
                <option value="">Select Type</option>
                <option value="Party">Party</option>
                <option value="Supplier">Supplier</option>
              </select>
            </div>

            <div className="form-group">
              <label>Credit Limit (₹)</label>
              <input type="number"
                className="form-control"
                value={form.credit}
                onChange={e => setForm({ ...form, credit:+e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Balance (₹)</label>
              <input type="number"
                className="form-control"
                value={form.balance}
                onChange={e => setForm({ ...form, balance:+e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>City</label>
              <input className="form-control"
                value={form.city}
                onChange={e => setForm({ ...form, city:e.target.value })}
                placeholder="City"
              />
            </div>

            <div className="form-group">
              <label>Status</label>
              <select
                className="form-control"
                value={form.status}
                onChange={e => setForm({ ...form, status:e.target.value })}
              >
                <option value="Active1">Active</option>
                <option value="Inactive">Inactive</option>
                
              </select>
            </div>

          </div>

          <div className="action-bar" style={{ padding:'0 16px 14px' }}>

            <button className="btn btn-primary" onClick={handleSave}>
              {editId ? "Update Customer Deatails" : "Save Customer Details"}
            </button>

            <button
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              ✕ Cancel
            </button>

          </div>

        </div>

      )}

      <div className="section-card">

        <div className="section-header">
          Customer List — {filtered.length} records
        </div>

        <div className="table-wrapper">

          <table className="data-table">

            <thead>
              <tr>
                <th className="text-left">Customer Name</th>
                <th className="text-left">GSTIN</th>
                <th className="text-left">Contact</th>
                <th className="text-right">Credit Limit</th>
                <th className="text-right">Balance (₹)</th>
                <th className="text-center">Type</th>
                <th className="text-center">Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((c, i) => (
                <tr key={c.Customerid || c.id || i}>
                  <td className="text-left" style={{ fontWeight: 600 }}>{c.Name || c.name}</td>
                  <td className="text-left" style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}>{c.GSTIN || c.gstin || '—'}</td>
                  <td className="text-left">{c.Contact || c.contact || '—'}</td>
                  <td className="text-right">₹{parseFloat(c.CreditLimit || c.credit || 0).toLocaleString()}</td>
                  <td className="text-right">₹{parseFloat(c.Balance || c.balance || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                  <td className="text-center">
                    <span className={`badge ${(c.Type || c.type) === 'Credit' ? 'badge-warning' : 'badge-success'}`}>
                      {c.Type || c.type}
                    </span>
                  </td>
                  <td className="text-center">
                    <span className={`badge ${(c.Status || c.status || 'Active1') === 'Active' || (c.Status || c.status) === 'Active1' ? 'badge-success' : ((c.Status || c.status) === 'Blocked' ? 'badge-danger' : 'badge-warning')}`}>
                      {(c.Status || c.status || 'Active1') === 'Active1' ? 'Active' : (c.Status || c.status || 'Active')}
                    </span>
                  </td>
                  <td className="text-center">
                    <button className="icon-btn" onClick={() => openEdit(c)} title="Edit">
                      <i className="bi bi-pencil-square"></i>
                    </button>
                    </td>
                </tr>
              ))}
            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}